import * as React from 'react'

import { Badge } from '../shadcn-ui/badge'

interface IGroupCountProps {
  children: React.ReactNode
}

export default function GroupCount({
  children,
}: IGroupCountProps): React.ReactElement {
  return (
    <Badge
      variant="outline"
      className="tw:min-w-5 tw:rounded-sm tw:px-1.5 tw:text-muted-foreground"
    >
      {children}
    </Badge>
  )
}
